import Common from './Common';

/**
 * Created by mestrad on 2018. 06. 28..
 */

export default Pagination;
import SearchRequest from "./Search/Request";

const $ = jQuery;

function Pagination( config ) {
    var pagination;
    var formattedData;
    var baseData;
    var pageNumber;
    init();
    refreshResultPage();

    function createCookie(name, value, days) {
        var expires;

        if (days) {
            var date = new Date();
            date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
            expires = "; expires=" + date.toGMTString();
        } else {
            expires = "";
        }
        document.cookie = encodeURIComponent(name) + "=" + encodeURIComponent(value) + expires + "; path=/";
    }

    function init()
    {
        pageNumber = config.paginationAttributes.current;
        createCookie('previousPage', pageNumber, 0.2);
        baseData = config.data;
        $("body").css("cursor", "default");
        if (config.pageSize == "all") {
            refresh();
            if(pageNumber < config.paginationAttributes.pageCount) window.addEventListener("scroll", lazyLoadEventFunction);
            $(".paginationjs").addClass("nnpHidden");
        } else {
            $('html, body').animate({ scrollTop: 0 }, 'fast');
            pagination = config.resultPagination;
            pagination.pagination({
                dataSource:  (done) => {
                    var result = [];
                    for (var i = 1; i < config.paginationAttributes.totalCount; i++) {
                        result.push(i);
                    }
                    done(result);
                },
                pageSize:  config.paginationAttributes.numItemsPerPage ||
                           config.pageSize,
                pageRange: config.paginationAttributes.pageRange || 5,
                pageNumber: pageNumber,
                showNavigator: true,
                formatNavigator: '<span><%= totalPage %>/<%= currentPage %></span> (' + config.paginationAttributes.totalCount + ' találat)',
                totalNumber: config.paginationAttributes.totalCount,
                callback: function (data, pagination) {
                    refresh();
                }
            });
            $("#pagination-container").removeClass("nnpHidden");
            config.resultPagination.addHook('afterPaging', function () {
                refreshResultPage();
            });
        }
        $('.number_of_results').html(config.paginationAttributes.totalCount);
        $(".nnpLoader").addClass("nnpHidden");
    }

    function refreshResultPage() {
        var pageData       = baseData;
        var disableCluster = false;

        if ( config.objectType === 'memorial' ) {
            var customFilterParam = Common.getUrlParam( 'custom_filter',
                document.location
            );
            var filterJson        = !! customFilterParam &&
                                    Common.isJsonString( customFilterParam ) ?
                                    JSON.parse( customFilterParam ) :
                                    false;
            var searchTypeFilter  = !! filterJson &&
                                    !! filterJson.nnp_search_types ?
                                    filterJson.nnp_search_types :
                                    false;
            disableCluster        = !! (
                !! searchTypeFilter && !! searchTypeFilter
                .filter( function ( filter ) {
                    return filter.type === 'memorial_corporate_combo' &&
                           filter.operator !== 'not' &&
                           filter.items.map( function ( item ) {
                               return +item[ 0 ];
                           } ).includes( 133126 );
                } ).length
            );
        }

        var data = disableCluster ? {
            pageData: pageData || [], disableCluster: disableCluster
        } : [ pageData ];

        $( config.domElements.searchForm ).trigger( 'searchResultReceived',
            data
        );
    }

    function refresh() {
        var view = "resultList_" + config.objectType + "_" + config.view;
        if (config.view == "tree") convertDataToTreeView();
        if (config.view == "namecard") convertDataToNameCardView();
        var template = Handlebars.compile($(config.templates.resultList).html());

        var value = !! $( '#order_type_result_list' ).val()
                    ? JSON.parse( $( '#order_type_result_list' ).val() )
                    : {};
        var order = {
            field: !! value ? value.field : 'name',
            type: !! value ? value.type : 'asc'
        };
        var html = template({
            data: formattedData,
            view: view,
            orderType: order.type,
            orderField: order.field,
            limit: Number(config.pageSize),
            pages: config.pages
        });
        if (config.pageSize !== "all") {
            config.resultList.html(html);
            initEvents();
        } else {
            if(pageNumber == 1) {
                config.resultList.html(html);
                initEvents();
            } else {
                $(config.domElements.resultList).append(html);
            }
        }
    }

    function initEvents()
    {
        $(".nnpResultListViewChanger").on("change", function(){
            config.view = $(".nnpResultListViewChanger input:checked").val();
            refresh();
            if(config.view == "tree"){
                $(".nnpResultListOrderContainer").addClass("nnpHidden");
            } else {
                $(".nnpResultListOrderContainer").removeClass("nnpHidden");
            }
        });
        $('#pagination-pagesize').on("change", function(){
            sendSearchRequest( $('#pagination-pagesize').val(), 1 );
        });
        $(".paginationjs-pages li").on("click", (e) => {
            e.preventDefault();
            $("body").css("cursor", "progress");
            var page = e.target.innerText;
            if(page === "«" ){
                page = config.paginationAttributes.current - 1;
            } else if (page === "»") {
                page = config.paginationAttributes.current + 1;
            }
           sendSearchRequest(config.pageSize, page);
        });
    }

    function lazyLoadEventFunction()
    {
        var lastItemPosition = document.getElementById("resultItem" + baseData[baseData.length-1].id).offsetTop;
        var activationOffset = 0.5;
        var activationPoint = lastItemPosition - (window.screen.height * activationOffset);
        if (window.pageYOffset > activationPoint) {
            sendSearchRequest( config.pageSize, pageNumber + 1 );
            window.removeEventListener("scroll", lazyLoadEventFunction);
        }
    }

    function sendSearchRequest( limit, page )
    {
        var searchConfig = {
            objectType: config.objectType,
            limit: limit,
            view: config.view,
            page: page,
            locale: config.locale,
            domElements: config.domElements,
        };
        if(limit !== "all"){
            searchConfig.templates = { resultList: "#tmpl-result-list" };
        } else {
            if(page == 1) {
                searchConfig.templates = { resultList: "#tmpl-result-list" };
            } else {
                searchConfig.templates = { resultList: "#tmpl-result-list-" + config.objectType + "-namecard-item" };
            }
        }
        SearchRequest(searchConfig);
    }

    function convertDataToTreeView()
    {
        var data;
        var dataList = [];
        var actualDate = baseData[0].actualDate;
        baseData.forEach(function(item){
            item.parentList.forEach(function(parent){
                if(!checkDataList(dataList, parent.id)) {
                    $.extend(parent, {actualDate: actualDate});
                    dataList.push(parent);
                }
            });
            if(!checkDataList(dataList, item.id)) {
                var title;
                item.nameList.forEach(function (name) {
                    if (name.active) title = name.title;
                });
                dataList.push({
                    id: item.id,
                    title: title,
                    parent: item.parent,
                    actualDate: actualDate
                });
            }
        });
        data = getNestedChildren( dataList );
        formattedData = data;
    }

    function checkDataList( dataList, id )
    {
        var exists = false;
        if(dataList.length != 0){
            dataList.forEach(function(dataItem){
                if(dataItem.id == id){
                    exists =  true;
                }
            });
        }
        return exists;
    }

    function getNestedChildren( array, parent )
    {
        var out = [];
        array.forEach(function(item){
            if(item.parent == parent) {
                var children = getNestedChildren(array, item.id);
                if(children.length) {
                    item.children = children;
                }
                out.push(item);
            }
        });
        return out;
    }

    function convertDataToNameCardView()
    {
        formattedData = baseData;
    }
}
